import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {CheckboxModule} from 'primeng/checkbox';
import {InputText} from 'primeng/inputtext';
import {PasswordModule} from 'primeng/password';
import {TooltipModule} from 'primeng/tooltip';
import {UsersService} from './users.service';
import {ConfigService} from './config.service';
// import { $ } from 'protractor';  Causes failure to compile

/*
** This component is a bit of a mis-nomer since it's used both for adding a user and editing a user.
*/
declare var $;

@Component({
	selector: 'manage-users-add-component',
	templateUrl: 'manage-users-add.component.html',
	styleUrls: ['manage-users-add.component.css']
})
export class ManageUsersAddComponent implements OnInit {
	usersService: UsersService;
	user: any;
	availableRoles: any[] = [];
	selectedRoles: any[] = [];
	location: Location;
	edit: boolean;
	pageLabel: string;
	passwordNote: string;
	disableUsername = false;
	rolesWarningVisible = false;
	usernameWarningVisible = false;
	passwordWarningVisible = false;
	showPassword = false;
	emailWarningVisible = false;
	nameWarningVisible = false;
	assignRolePermission = false;

	constructor(usersService: UsersService, private configService: ConfigService, location: Location, private route: ActivatedRoute) {
		this.usersService = usersService;
		this.location = location;
		this.user = { username: 'username', name: 'name', email: 'email@domain.com', password: 'temp1234',
				address: 'address', mobile: 'mobile', organization: 'organization', phone: 'phone', title: 'title' };
	}

	ngOnInit() {
		// Get all available user roles, not just the ones associated with this user.
		// Then get the permissions for each role and assign to role[permissionList].
		this.usersService.getAllAvailableUserRoles()
			.subscribe (data => {
				// console.log(data);
				this.availableRoles = data.roles;
				console.log(this.availableRoles);
				this.availableRoles.forEach((role) => {
					role['value']= role.name;
					role['label']= role.name + ' (' + role.description + ')';
					this.usersService.getRolePermissions(role.name)
						.subscribe ( permissions => {
							// console.log(role.name);
							console.log(permissions.permissions);
							role['permissionList'] = permissions.permissions;
							const perm = permissions.permissions;
							let tooltip = '';
							for ( let i=0; i<perm.length; i++) { 
								tooltip += '<span class="tooltipHeader">' + perm[i].name + '</span>' + ' - ' + perm[i].description + '<br>';
							}
							role['tooltip'] = tooltip;
						});
				}, this);
				// console.log(this.availableRoles);
			});

		// Does this user have the ability to assign/change roles?
		this.usersService.hasPermission (this.configService.userName, 'users.roles.edit')
			.subscribe ( hasPermission => {
				if ( hasPermission === true ) {
					this.assignRolePermission = true;
					/*
					// cat - move this to a routine called from above subscribe
					this.availableRoles 
					*/
				}
			});

		// Fill elements with either defaults for a new user or actual values for existing user.
		this.route.params.forEach((params: Params) => {
			const username = params['user'];

			if ( username === undefined) {
			//
			// new user
			//
				this.pageLabel = 'Add User';
				this.user = { username: 'username', name: 'name', email: 'email@domain.com', password: 'temp1234',
					address: 'address', mobile: 'mobile', organization: 'organization', phone: 'phone', title: 'title' };
				this.edit = false;
				this.disableUsername = false;
				this.passwordNote = '';
			} else {
			//
			// existing user
			//
				this.pageLabel = 'Edit User';
				this.usersService.getUser(username)
					.subscribe (data => {
						this.user = data;
						this.usersService.getUserRoles(username)
							.subscribe (roles => {
								this.user['roles'] = roles['roles'];
								// console.log(this.user);
								this.checkAppropriateRoles();
							});
					});
				this.edit = true;
				this.disableUsername = true;  // don't allow existing username to change
				this.passwordNote = '(leaving a blank password indicates no change to password)';
			}
		});
	}

	//
	// Check the checkboxes for all roles that apply to this user.
	// This relies on the id of the checkbox to match the id of the role which
	// should work because the list of user roles comes from the database as well.
	//
	checkAppropriateRoles() {
		console.log(this.user);
		const roles = this.user.roles;
		console.log(roles);
		roles.forEach(function(element) {
			(<HTMLInputElement><any>document.getElementById(element.id)).checked = true;
		});

		roles.forEach(function(role) {
			const rArray = this.availableRoles.filter (r => {return role.name === r.name});
			console.log(rArray);
			if ( rArray.length > 0 ) {
				// do not use push here - primeng 
				this.selectedRoles = this.selectedRoles.concat(rArray);
			}
		}, this);



				// this.selectedRoles = this.availableRoles.slice(0,1);
		console.log(this.availableRoles);
	}

	//
	// If password was previously visible, changes to "****" and vice versa.
	//
	togglePassword() {
		this.showPassword = !this.showPassword;
		if ( this.showPassword === true ) {
			$('#passwordField').attr('type', 'text');
		} else {
			$('#passwordField').attr('type', 'password');
		}
	}

	// Create or update (depending on current state) the user.
	// Verifies, superficially, validity of submissions, then calls user web services.
	submitUser() {
		// console.log(this.user);
		let errors = false;

		// First assemble the roles selected for the user whether it is a new or existing user.
		const roles = [];
		this.availableRoles.forEach(function(element) {
			if ( (<HTMLInputElement><any>document.getElementById(element.id)).checked ) {
				// console.log(element.id);
				roles.push ( element );
			}
		});

		//
		// validate data - was a role assigned, is email a valid e-mail address, ...
		//
		if ( roles.length === 0 ) {
			this.rolesWarningVisible = true;
			errors = true;
		} else {
			this.rolesWarningVisible = false;
		}

		if ( this.user.username == null || this.user.username.length === 0 ) {
			this.usernameWarningVisible = true;
			errors = true;
		} else {
			this.usernameWarningVisible = false;
		}

		if ( this.user.name == null || this.user.name.length === 0 ) {
			this.nameWarningVisible = true;
			errors = true;
		} else {
			this.nameWarningVisible = false;
		}

		if ( this.user.email == null || this.user.email.length === 0 || !this.user.email.includes('@')) {
			this.emailWarningVisible = true;
			errors = true;
		} else {
			this.emailWarningVisible = false;
		}

		if ( this.edit === false && ( this.user.password == null || this.user.password.length === 0 )) {
			this.passwordWarningVisible = true;
			errors = true;
		} else {
			this.passwordWarningVisible = false;
		}

		// If errors were found, don't save information.  Stay on same page.
		if ( errors === true ) {
			return;
		}

		// made it to here - user data must be acceptable
		this.user.roles = roles;

		// Now call user web services to either create a new user or update existing user.
		if ( this.edit === false ) {
			this.usersService.addUser(this.user)
				.subscribe (() => {
						if ( this.assignRolePermission === true ) {
								this.usersService.addUserRoles(this.user)
									.subscribe(() => this.goBack());
						} else {
							// maybe alert user?
							this.goBack();
						};
					});
		} else {
			this.usersService.updateUser(this.user)
				.subscribe (() => {
						if ( this.assignRolePermission === true ) {
							this.usersService.addUserRoles(this.user)
								.subscribe(() => this.goBack());
						} else {
							// maybe alert user?
							this.goBack();
						};
				});
		}
	}

	goBack(): void {
		this.location.back();
	}
}
